// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1yFML","col":"styles_col__2s6qu"};